// Configuración del Cuaderno — SIN dependencias de Node.
//
// Esta parte (ruta base, etiquetas y construcción de URLs) es segura de importar
// desde cualquier sitio, incluidos componentes cliente (p. ej. Footer, que a su
// vez es importado por páginas `use client`). El cargador de contenido, que sí
// usa `node:fs`, vive aparte en `@/lib/cuaderno` y solo debe importarse desde
// código de servidor.
//
// ── Renombrar la sección (p. ej. /ideas → /cuaderno) ────────────────────────
// El naming es provisional (Santi decidirá entre /ideas y /cuaderno). Para
// renombrar SOLO hay que tocar dos cosas, y ninguna ruta está hardcodeada fuera
// de este fichero:
//   1) Cambiar `CUADERNO_BASE_PATH` (y opcionalmente `CUADERNO_LABEL`) aquí.
//   2) Renombrar la carpeta de rutas `src/app/ideas` → `src/app/<nuevo>`
//      (el App Router deriva la URL del nombre de la carpeta; es lo único que
//      no se puede parametrizar) y las claves de `outputFileTracingIncludes`.
// Todos los enlaces, canonicals, OG, sitemap y RSS se construyen a partir de
// `CUADERNO_BASE_PATH`, así que ese cambio se propaga solo.

import { SITE_URL } from "@/lib/seo";

// Ruta base de la sección. Fuente única de verdad; ver nota de renombrado arriba.
// Debe coincidir con el nombre de la carpeta en `src/app/`.
export const CUADERNO_BASE_PATH = "/ideas";

// Etiqueta visible (nav, breadcrumb, títulos). Se ajusta junto al naming final.
export const CUADERNO_LABEL = "Ideas";

// Descripción de la sección para metadata del listado y del feed.
export const CUADERNO_DESCRIPTION =
  "Notas sobre feedback, hostelería y el oficio de escuchar a quien no suele hablar. Sin ruido: solo lo que merece leerse dos veces.";

/**
 * Construye una ruta absoluta dentro de la sección a partir de la base.
 * `piecePath()` → "/ideas"; `piecePath("mi-slug")` → "/ideas/mi-slug".
 */
export function piecePath(slug) {
  return slug ? `${CUADERNO_BASE_PATH}/${slug}` : CUADERNO_BASE_PATH;
}

/** URL absoluta (para canonical, OG, sitemap, RSS). */
export function pieceUrl(slug) {
  return `${SITE_URL}${piecePath(slug)}`;
}
